import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { fillLegalDate } from "../../../utils/legalDate";
import LegalVersionNote from "../../legal/LegalVersionNote";
import { legalSupplement, isSupplementKey } from "../../../utils/legalSupplements";

const SectionTitle = ({ children }) => (
    <Text
        fontWeight={700}
        fontSize={'18px'}
        lineHeight={'28px'}
        color={'#1E1517'}
        mt={'8px'}
    >
        {children}
    </Text>
);

const SectionParagraph = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const Cookie = ({ archivedVersion }) => {
    const { t, i18n } = useTranslation("cookies");

    const sections = [
        {
            title: 's1.title',
            paragraphs: ['s1.p1'],
        },
        {
            title: 's2.title',
            paragraphs: ['s2.p1', 's2.p2', 's2.p3', 's2.p4'],
        },
        {
            title: 's3.title',
            paragraphs: ['s3.p1', 's3.p2'],
        },
        {
            title: 's4.title',
            paragraphs: ['s4.p1', 's4.p2'],
        },
        {
            title: 's5.title',
            paragraphs: ['s5.p1', 's5.p2', 's5.p3', 's5.p4', 's5.p5', 's5.p6'],
        },
        {
            title: 's6.title',
            paragraphs: ['s6.p1'],
        },
    ];

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'4px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Metadane */}
                        <Flex gap={'16px'} flexDirection={{ base: 'column', sm: 'row' }} mb={'32px'}>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('effective_date'), 'cookies', archivedVersion)}
                            </Text>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('version'), 'cookies', archivedVersion)}
                            </Text>
                        </Flex>

                        <LegalVersionNote doc="cookies" archivedVersion={archivedVersion} />
                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} />

                        {/* Sekcje */}
                        <Flex gap={'32px'} flexDirection={'column'} w={'full'}>
                            {sections.map((section) => (
                                <Flex key={section.title} flexDirection={'column'} gap={'12px'}>
                                    <SectionTitle>
                                        {t(section.title)}
                                    </SectionTitle>
                                    {section.paragraphs.filter((pKey) => !archivedVersion || !isSupplementKey('cookies', pKey)).map((pKey) => (
                                        <SectionParagraph key={pKey}>
                                            {t(pKey, { defaultValue: legalSupplement('cookies', i18n.language, pKey) })}
                                        </SectionParagraph>
                                    ))}
                                </Flex>
                            ))}
                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default Cookie;
